<template>
  <div>
    <div class="text">
      <div class="left">
        <i></i>
        <RouterLink target="_blank" to="/video">
          <h3>直播预告/回放</h3>
        </RouterLink>
        <a target="_blank" href=""> </a>
      </div>
      <div class="right">
        <a href="javascript:;" @click="hitTimeLine">
          <span>更多</span>
          <el-icon><ArrowRight /></el-icon>
        </a>
      </div>
    </div>
    <Transition name="fade">
      <div v-if="timeLine.length" class="video">
        <el-timeline>
          <el-timeline-item
            left
            v-for="item in timeLine"
            :key="item.timeID"
            :timestamp="item.timeStamp"
            placement="top"
          >
            <a href="javascript:;" @click="hitTimeLine">{{ item.timeText }}</a>
          </el-timeline-item>
        </el-timeline>
      </div>
      <TimelineSkeleton v-else />
    </Transition>
  </div>
</template>

<script>
import TimelineSkeleton from "./timeline-skeleton.vue";
import { ElMessageBox } from "element-plus";
import { ref, onUnmounted } from "vue";
import { findTimeLine } from "@/api/news";
export default {
  components: {
    TimelineSkeleton,
  },
  setup() {
    const timeLine = ref([]);
    const hitTimeLine = () => {
      ElMessageBox.alert(
        "<p>请添加官网老师微信获取更多课程信息</p><p>刘老师(微信):18019934025</p><p>徐老师(微信):13205515869</p><p>黄老师(微信):13075567156</p><p>刘校长(微信):18505513002</p>",
        "欢迎来到山河医学网",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    };
    findTimeLine({ limit: 5 })
      .then((data) => {
        timeLine.value = data;
      })
      .catch((error) => {
        console.log(error);
      });

    return { hitTimeLine, timeLine };
  },
};
</script>

<style lang="less" scoped>
.video {
  margin: 15px 10px 5px 10px;
  a {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    &:hover {
      color: @shColor;
    }
  }
}
</style>
